import React from 'react';

export default function MethodText({ code }) {
	return <p>{code}</p>
}